import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67019834"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container scrolled" }
const _hoisted_2 = { class: "list-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Profissionais", -1))
const _hoisted_4 = { class: "list-header" }
const _hoisted_5 = { class: "item-data" }
const _hoisted_6 = { class: "item-operations" }
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          class: "btn btn-new",
          to: { name: 'professional_new' }
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Cadastro professional ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("ul", {
        class: _normalizeClass({
          'list-items': true,
          loading: _ctx.isLoading,
          'empty-list': !_ctx.isLoading && !_ctx.professionals.length,
        })
      }, [
        (!_ctx.isLoading)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList((_ctx.professionals as ProfessionalModel[]), (professional) => {
              return (_openBlock(), _createElementBlock("li", {
                key: professional.id
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("strong", null, _toDisplayString(professional.name), 1),
                  _createElementVNode("p", null, _toDisplayString(professional.actuations?.[0].specialty_description || "Especialidade não definida") + " na " + _toDisplayString(professional.actuations?.[0].clinic_name || "Clinica não definida"), 1),
                  _createElementVNode("p", null, "E-mail: " + _toDisplayString(professional.email), 1),
                  _createElementVNode("p", null, "Telefone: " + _toDisplayString(professional.phone.maskPhone()), 1)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_router_link, {
                    class: "btn",
                    to: { name: 'professional_edit', params: { professional_id: professional.id } }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, { icon: ['fa', 'pen-square'] })
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _createElementVNode("button", {
                    class: "btn btn-delete",
                    onClick: ($event: any) => (_ctx.deleteProfessional(professional.id))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fa', 'trash'] })
                  ], 8, _hoisted_7)
                ])
              ]))
            }), 128))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ]))
}